module.exports = __webpack_public_path__ + "img/bell-ring-sharp-light.1fd544b1.svg";